export default "__VITE_ASSET__b772a630__"